export default function getAudioFileDuration(file) {
  return new Promise(resolve => {
    const reader = new FileReader();
    reader.onload = evt => {
      const audioContext = new (window.AudioContext || window.webkitAudioContext)();
      audioContext.decodeAudioData(evt.target.result, buffer => {
        resolve(buffer.duration);
      });
    };
    reader.readAsArrayBuffer(file);
  });
}
